<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <p>
    {{ 'cart.cart-help-modal.description' | translate }}
  </p>
  <ul>
    <li *ngFor="let orderHelp of helpText">
      <p class="spacing--margin-none-vertical">
        <b>{{ orderHelp.title }}</b>
      </p>
      <p class="spacing--margin-none-vertical">
        {{ orderHelp.description }}
      </p>
      <p *ngIf="orderHelp.attention" class="spacing--margin-none-bottom">
        <b>{{ orderHelp.attention.title }}</b>
        {{ orderHelp.attention.description }}
      </p>
    </li>
  </ul>
</agr-dialog>
